import { ComponentProps } from "react";
import { Body, Ellipsis } from "@songtradr-one/components-frontend";
import { Props, text } from "./GeneralColumn.Parts";

export const GeneralColumn = ({
  content,
  disableTooltip = false,
  className,
}: Props) => (
  <Ellipsis disableTooltip={disableTooltip}>
    <Body className={className}>{content || text.notAvailable}</Body>
  </Ellipsis>
);

export const GeneralColumnWithTooltipDisabled = (
  props: ComponentProps<typeof GeneralColumn>,
) => <GeneralColumn {...props} disableTooltip />;
